import type { Field, CreateFieldRequest, CreateWorkflowField } from "~/types/api";

export type FieldUnion = CreateFieldRequest | CreateWorkflowField | Field;

export const isFieldType = (field: FieldUnion): field is Field => {
  return "id" in field && typeof (field as Field).id === "number" && (field as Field).id > 0;
};
